import { render } from "./facebook-icon.vue?vue&type=template&id=a6396a0e"
import script from "./facebook-icon.vue?vue&type=script&lang=js"
export * from "./facebook-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__